/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function VideoDeliveryItemEditViewAudioChannelMappingAudioSidecarController(
    this: JS5Object,
    _: JS5Object,
    AudioChannelMappingService: JS5Object
) {

    this.$onInit = () => {
        this.audioMediaAcceptProfiles = _.filter(this.mediaAcceptProfiles, {type: 'AUDIO'});
        this.audioRoles = _.filter(this.roles, {type: 'Audio'});
        this.audioChannelMapGroups = AudioChannelMappingService.audioChannelMapGroups;
    };

    this.addGroup = () => {
        AudioChannelMappingService.addAudioSidecar();
        this.editorForm.$setDirty();
    };

    this.removeGroup = (audioChannelMapGroupIndex: number) => {
        AudioChannelMappingService.removeAudioSidecar(audioChannelMapGroupIndex);
        this.editorForm.$setDirty();
    };

    this.swap = (audioChannelMapGroupIndex: number, offset: number) => {
        AudioChannelMappingService.swapAudioSidecars(audioChannelMapGroupIndex, audioChannelMapGroupIndex +offset);
        this.editorForm.$setDirty();
    }
}

angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAudioChannelMappingAudioSidecar', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/deliveryItemsVideoEditViewAudioChannelMappingAudioSidecarComponent/delivery-items-video-edit-view-audio-channel-mapping-audio-sidecar-template.html',
    controller: VideoDeliveryItemEditViewAudioChannelMappingAudioSidecarController,
    bindings: {
        editData: '<',
        mediaAcceptProfiles: '<',
        roles: '<',
        languages: '<'
    }
});
